import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	ViewChild,
	Input,
} from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { CommentsListComponent } from "../../../shared/shared-components/modal/comments-list/comments-list.component";
import { WarningModalComponent } from "../../../shared/shared-components/modal/warning-modal/warning-modal.component";
import { HecResponse } from "../../../shared/shared-interfaces/hecResponse";
import { GoogleAnalyticsService } from "../../../shared/sharedServices/google-analytics.service";
import { LoaderService } from "../../../shared/sharedServices/loader.service";
import { SharedService } from "../../../shared/sharedServices/shared.service";
import { HEC_CONSTANTS } from "../../../utilities/constants";
import { ProfileService } from "../profile/services/profile.service";
import { PucaService } from "./services/puca.service";
import { PucaDataService } from "./services/puca-data.service";
import { EducationService } from "./components/education/services/education.service";
import { AttestationModel } from "./components/attestation-details/model/attestationModel";
import { decrypt } from "../../../../app/utilities/utilityFunctions";

@Component({
	selector: "kt-puca",
	templateUrl: "./puca.component.html",
	styleUrls: ["./puca.component.scss"],
})
export class PucaComponent implements OnInit, OnDestroy {
	public dropdownList: any;
	public dasApplicationData: any = new AttestationModel();

	public pucaApplication: any;
	public appType: string;
	public pageState: number = 1;
	public wizard: any;
	public profileUpdated: boolean = false;
	public submitted = false;
	public formType: string;
	public isMaxNewApplicationsReachesInSaved: boolean;
	public isMaxNewAppplicationReachesInProcess: boolean = false;
	public isMaxNewApplicationsIsInRevision: boolean;
	public backCase: any;
	public loader: boolean = false;
	public isAlertVisible: boolean = false;
	public alertType: string = "";
	public alertMsgValue: string = "";
	public applicationStatus: any;
	public dataWizardType: string = "step";
	public appId: any;
	public cancelApplicationStatusesList: Array<any> = [
		60082, 60083, 60085, 60088, 600810, 600812, 600814, 600816, 600831,
		600828, 600827,
	];
	@Input() showTermsAndConditions: boolean = true;
	public mutationObserver: MutationObserver;
	@Input() isAdmin: boolean = false;
	public isBatchActive: boolean = true;
	private profileDropdownPromise: Promise<any>;
	public termsAndConditionsInstruction: string = `<div class="terms-heading"> <h1>Instructions For US-Pak Knowledge Corridor</h1></div> <div class="instruction-note">
	<p>Please Read all instructions and information carefully.</p>
	</div> <div> <p>PHD Scholarship under US-Pak Knowledge Corridor Project is offered in three categories</p> </div> <ol>
	<div class="terms-heading"> <h2><li>Category – I (Admission in top 50 QS World Ranked US University):</li></h2></div>
	<div class="terms-content-area">
	<p>This scholarship is offered to those applicants who secure admission in top 50 QS World Ranked US Universities and
	having GRE-General Score or HAT Score. The applicant must satisfy general eligibility criteria</p>
	</div> <div class="terms-heading"> <h2><li>Category – II (Admission in top 300 QS World Ranked US University):</li></h2></div>
	<div class="terms-content-area"> This scholarship is offered to those applicants who secure admission in top 300 QS World Ranked US
	Universities and having GRE – General Score or HAT Score. The applicant must satisfy the general
	eligibility criteria.</div> <div class="terms-heading"> <h2><li>Category – III (Admission along with complete tuition waiver):</li></h2></div>
	<div class="terms-content-area"> This scholarship is offered to those prospective applicants who secure admission along with complete tuition waiver
	in designated US Universities (List of Universities available on US – Pak Knowledge Corridor web page of HEC website). The applicant must satisfy
	general eligibility criteria. </div> </ol> <div class="terms-heading"> <h2>Note:</h2></div> <ol> <div class="terms-content-area"> <li>The Scholar shall be required, In case of selection for Ph.D. Scholarship under US-Pak Knowledge Corridor: <ol type="a"> <li>To mark a lien in favor of HEC on immovable property worth PKR 6.00 Million.</li> <li>To sign a bond/ contract with Higher Education Commission Islamabad that the scholar will come back to Pakistan immediately after completion of his Ph.D. studies to serve the country for a period specified in the agreement.</li> <li>To submit other legal documents as and when required.</li> </ol> </li> <li>US – Pak Knowledge Corridor (HEC) application portal will be open round the year where the applicant has secured admission along with complete tuition support in any designated US University. However, application completed in all respects along with required documents must reach the office of US – Pak Knowledge Corridor not later May 30th in case of scholarship for upcoming Fall Semester and September 30th in case of scholarship for upcoming Spring Semester. </li> <li>Please visit US – Pak Knowledge Corridor web page (especially FAQs) on HEC website for detailed information such as eligibility criteria, requirements for issuance of provisional award letter and other relevant information.</li> <li><u><b>Please send scanned copies of application form along with other required documents on the following email address.</b></u> Documents shall be attested by gazetted officer of Grade 17/ above. <u>At this stage you are not required to submit hard copies</u> of this application and other documents. You may be asked to submit hard copies later, when required.</li> </div> <div>
	<p> <a href="Shkosar@hec.gov.pk">Shkosar@hec.gov.pk</a> <br> <a href="mqarshad@hec.gov.pk">mqarshad@hec.gov.pk</a></p> </div> </ol>`;

	@ViewChild("wizard", { static: false }) el: ElementRef;
	@ViewChild("kmProfile", { static: true }) rootComponent: ElementRef;

	constructor(
		private profileService: ProfileService,
		private router: Router,
		private dasService: PucaService,
		private activatedRoute: ActivatedRoute,
		private sharedServices: SharedService,
		private matDialog: MatDialog,
		private cdr: ChangeDetectorRef,
		private educationServices: EducationService,
		private dasDataService: PucaDataService,
		private loaderService: LoaderService,
		private gaService: GoogleAnalyticsService,
		private pucaService: PucaService
	) {}

	async ngOnInit() {
		this.formType = this.dasDataService.formView;
		if (this.formType && this.formType === "view")
			this.showTermsAndConditions = false;

		this.profileDropdownPromise = this.getProfileDropdownData();

		await this.getIsMaxApplicationExist();
		await this.getApplicationFormData();
		//for admin
		if (this.dasDataService.isAdmin && this.formType == "view")
			this.dasStart();
		// for applicants
		else {
			if (
				!this.isMaxNewApplicationsReachesInSaved &&
				!this.isMaxNewAppplicationReachesInProcess &&
				!this.isMaxNewApplicationsIsInRevision
			) {
				//new app i guess
				if (
					this.isBatchActive &&
					!this.dasDataService.isSaveOnly // || this.dasDataService.isCategory1
				)
					this.dasStart();
				else if (this.dasDataService.isSaveOnly)
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You cannot create a new application. Only Saved Application can be submitted."
					);
				else {
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You cannot apply for this scholarship because scholarship is currently not active."
					);
				}
			} else if (
				this.isMaxNewApplicationsReachesInSaved &&
				this.formType == "edit"
			) {
				//saved app
				if (
					this.isBatchActive ||
					this.dasDataService.isSaveOnly
					//|| this.dasDataService.isCategory1
				) {
					this.dasStart();
				} else {
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You cannot apply for this scholarship because scholarship is currently not active."
					);
				}
			} else if (
				this.isMaxNewAppplicationReachesInProcess &&
				this.formType == "view"
			) {
				this.dasStart();
			} else if (
				this.isMaxNewApplicationsReachesInSaved &&
				this.formType == "view"
			) {
				this.dasStart();
			} else if (
				this.isMaxNewAppplicationReachesInProcess &&
				this.formType == "pucaRevision"
			) {
				if (this.isBatchActive) this.dasStart();
				else {
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You cannot apply for this scholarship because scholarship is currently not active."
					);
				}
			} else if (
				this.isMaxNewApplicationsIsInRevision &&
				this.formType == "edit"
			) {
				this.dasStart();
			} else {
				if (this.isMaxNewAppplicationReachesInProcess) {
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You already have a Submitted application. Please open the application from dashboard"
					);
				} else {
					this.ModalComponent(
						WarningModalComponent,
						"PUCA Service",
						"You already have a saved application. Please open the application from dashboard"
					);
				}
			}
		}

		this.gaService.setPage(
			this.router.url,
			this.formType == "pucaRevision"
				? "PUCA Revision Requested"
				: "PUCA Application Form"
		);
	}

	public async onTermsAccepted(): Promise<void> {
		if (!this.profileDropdownPromise) {
			this.profileDropdownPromise = this.getProfileDropdownData();
		}
		await this.profileDropdownPromise;

		this.showTermsAndConditions = false;
		this.cdr.detectChanges();
		this.setupKTWizard();
	}

	ngOnDestroy() {
		this.dasDataService.formView = undefined;
		this.dasDataService.applicationId = undefined;

		if (this.mutationObserver) this.mutationObserver.disconnect();
	}

	public async dasStart() {
		this.appType = this.router.url;
		if (!this.profileDropdownPromise) {
			this.profileDropdownPromise = this.getProfileDropdownData();
		}
		await this.profileDropdownPromise;
		if (this.dasDataService.applicationId) {
			this.appId = this.dasDataService.applicationId;
			this.getDasApplication(this.dasDataService.applicationId);
		}
	}

	public getIsMaxApplicationExist() {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		return new Promise((resolve, reject) => {
			let data = decrypt(localStorage.getItem("esp-profile-details"));
			data = JSON.parse(data);
			this.dasService
				.getIsMaxApplicationExist(data["profileId"])
				.subscribe(
					(res: HecResponse) => {
						this.loader = false;
						this.loaderService.setValue(this.loader);
						this.cdr.detectChanges();
						if (res.code === 0) {
							if (res.result.status === "Saved") {
								this.isMaxNewApplicationsReachesInSaved = true;
							} else if (
								res.result.status === "InProcess" ||
								res.result.status === "Submitted" ||
								res.result.status === "Approved" ||
								res.result.status === "Rejected"
							) {
								this.isMaxNewAppplicationReachesInProcess =
									true;
							} else if (
								res.result.status === "Revision Required"
							) {
								this.isMaxNewApplicationsIsInRevision = true;
								this.dasDataService.isInRevision = true;
							}

							resolve(this.isMaxNewAppplicationReachesInProcess);
							resolve(this.isMaxNewApplicationsReachesInSaved);
							resolve(this.isMaxNewApplicationsIsInRevision);
						}
					},
					(error) => {
						if (
							error.status ==
							HEC_CONSTANTS.HTTP_RESPONSE.NOT_FOUND
						) {
							this.loader = false;
							this.loaderService.setValue(this.loader);
						}
					}
				);
		}).catch(function (error) {});
	}

	public getProfileDropdownData() {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		return new Promise((resolve, reject) => {
			this.profileService.getProfileFormData().subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.dropdownList = res.data;
						this.cdr.detectChanges();
						resolve(this.dropdownList);
						this.cdr.detectChanges();
					}
				},
				(error) => {
					if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.NOT_FOUND) {
						this.loader = false;
						this.loaderService.setValue(this.loader);
					}
				}
			);
		}).catch(function (error) {});
	}

	ngAfterViewInit(): void {
		if (!this.showTermsAndConditions) this.setupKTWizard();
	}

	setupKTWizard = (retryCount: number = 0) => {
		if (!this.el || !this.el.nativeElement) {
			if (retryCount < 10) {
				setTimeout(() => this.setupKTWizard(retryCount + 1), 0);
			}
			return;
		}

		this.wizard = new KTWizard(this.el.nativeElement, {
			startStep: 1,
		});
		this.wizard.on("beforeNext", (wizardObj) => {});

		this.wizard.on("change", () => {
			setTimeout(() => {
				KTUtil.scrollTop();
			}, 500);
		});
	};

	public goToPage(number: number) {
		if (!this.wizard) {
			this.setupKTWizard();
		}

		if (this.wizard) {
			this.wizard.goTo(number);
		}

		this.pageState = number;
	}

	getDasApplication(appId): void {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.sharedServices.getApplicationData(appId).subscribe(
			(res: HecResponse) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (
					res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK ||
					res.code == 0
				) {
					this.pucaApplication = res.result;
					this.applicationStatus =
						this.cancelApplicationStatusesList.find(
							(status) =>
								status == res.result.pucaApplicationDto.statusId
						);
					this.cdr.detectChanges();
				} else {
				}
			},
			(error) => {
				if (error.status == HEC_CONSTANTS.HTTP_RESPONSE.NOT_FOUND) {
					this.loader = false;
					this.loaderService.setValue(this.loader);
				}
			}
		);
	}

	public getDasFormDropdowns() {}

	goNext() {
		if (!this.wizard) {
			this.setupKTWizard();
		}

		if (this.wizard) {
			this.wizard.goNext();
			this.wizard.goNext();
		}

		this.pageState = this.pageState + 1;
		this.cdr.detectChanges();
	}

	goBack(backCase?) {
		this.backCase = backCase;

		if (!this.wizard) {
			this.setupKTWizard();
		}

		if (this.wizard) {
			this.wizard.goPrev();
			this.wizard.goPrev();
		}

		this.pageState = this.pageState - 1;
		this.cdr.markForCheck();

		if (this.mutationObserver) this.mutationObserver.disconnect();
	}

	tabClick(tabNumber) {
		this.pageState = tabNumber;
		this.cdr.detectChanges();
	}

	onSubmit(e) {
		this.submitted = true;
	}

	public getEducationData(event) {
		this.dasApplicationData.dasApplicationDto = event;
	}

	public getUpdatedData(event) {}

	public ModalComponent(Component, title, message, type?): any {
		const dialogRef = this.matDialog.open(Component, {
			width: "70vw",
			height: "60vh",
			backdropClass: "landingpage-popup",
			panelClass: "landingpage-popup-inner",
			disableClose: true,
			autoFocus: false,
			data: { title: title, message: message },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (type != "cancel") {
				if (!result || result) {
					this.router.navigate(["/"]);
				}
			} else if (type == "cancel") {
				if (result) {
					this.cancelAppReq();
				}
			}
		});
	}

	public viewComments(appId) {
		const dialogRef = this.matDialog.open(CommentsListComponent, {
			width: "70vw",
			height: "60vh",
			backdropClass: "landingpage-popup",
			panelClass: "landingpage-popup-inner",
			disableClose: true,
			autoFocus: false,
			data: { appId: appId, pucaApplication: this.pucaApplication },
		});
	}

	public cancelAppReq() {
		let payload = {
			data: {},
		};
		this.loader = true;
		this.loaderService.setValue(this.loader);

		this.dasService.cancelApplication(payload).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.router.navigate(["/"]);
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.isAlertVisible = true;
					this.alertType = "error";
					this.alertMsgValue = "Error in Cancelling Application";
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.isAlertVisible = true;
				this.alertType = "error";
				this.alertMsgValue = "Error in Cancelling Application";
				this.cdr.detectChanges();
			}
		);
	}

	public cancelApplication() {
		const res = this.ModalComponent(
			WarningModalComponent,
			"Degree Attestation Service",
			"Are you sure you want to cancel this application ?",
			"cancel"
		);
	}

	public getApprovedDetails(appId) {
		// const dialogRef = this.matDialog.open(ApprovedDetailsComponent, {
		//   width: '70vw',
		//   height: '60vh',
		//   backdropClass: 'landingpage-popup',
		//   panelClass: 'landingpage-popup-inner',
		//   disableClose: true,
		//   autoFocus: false,
		//   data: { appId:appId }
		//   });
		//   dialogRef.afterClosed().subscribe(result => {
		//   });
	}

	private async getApplicationFormData() {
		let data = decrypt(localStorage.getItem("esp-profile-details"));
		data = JSON.parse(data);
		const res: any = await this.pucaService
			.getApplicationFormData(data["profileId"])
			.toPromise();
		if (res.code == 0) {
			this.isBatchActive = res.result.isBatchActive;
			this.dasDataService.isBatchActive = this.isBatchActive;
			this.dasDataService.isSaveOnly = res.result.isSaveMode;
			this.dasDataService.isCategory1 = res.result.isCategoryType1;
			// use the backend instruction when present, but always keep the US-Pak heading
			if (res.result.instruction && res.result.instruction.trim()) {
				const headingBlock = `<div class="terms-heading"> <h1>Instructions For US-Pak Knowledge Corridor</h1></div>`;
				let instruction = res.result.instruction;
				if (instruction.indexOf("Instructions For US-Pak Knowledge Corridor") === -1) {
					instruction = headingBlock + instruction;
				}
				this.termsAndConditionsInstruction = instruction;
			}
		}
	}

	showComments = () => {
		return (
			this.formType == "view" ||
			(this.formType == "edit" && this.isMaxNewApplicationsIsInRevision)
		);
	};
}
